import React from 'react';
import * as S from './ConsultationsList.styled';
import { useSelector } from 'react-redux';
import Table from './components/Table';
import { ConsultationsListItemsSelector } from './ConsultationsListSlice';

const ConsultationsList: React.FC = () => {
  // Список запрошенных консультаций
  const consultations = useSelector(ConsultationsListItemsSelector);

  return (
    <S.Wrap>
      <Table items={consultations} />
    </S.Wrap>
  );
};

export default ConsultationsList;
